import { TICKETING_TOOL_VISIBILITY, TICKETING_TOOL_SET_URL, TICKETING_TOOL_ORG_DATA } from 'src/common/actions/constants';

const defaultState = {
  visible: false,
  orgData: {},
  ticketingToolURL: '',
};

export default (state = defaultState, action) => {
  const { data } = action;
  switch (action.type) {
    case TICKETING_TOOL_VISIBILITY: {
      return {
        ...state,
        visible: data,
      };
    }
    case TICKETING_TOOL_SET_URL: {
      return {
        ...state,
        ticketingToolURL: data,
      };
    }
    case TICKETING_TOOL_ORG_DATA: {
      return {
        ...state,
        orgData: data,
      };
    }
    default:
      return state;
  }
};
